import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';

const LazyImage = memo(({ src, alt }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1, // Adjust as needed
  });

  return (
    <div className="imginn" ref={ref}>
      {inView && <img src={src} alt={alt} />}
    </div>
  );
});

LazyImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default LazyImage;
